import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0402 from "../../../lesson/course-04/lesson-02/lesson";
import lesson0418 from "../../../lesson/course-04/lesson-18/lesson";
import lesson0419 from "../../../lesson/course-04/lesson-19/lesson";
import lesson0420 from "../../../lesson/course-04/lesson-20/lesson";
import lesson0421 from "../../../lesson/course-04/lesson-21/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "2047f953-33f7-455f-a9ee-5bb424637a80",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0402),
    lesson: lesson0402,
  },
  {
    id: "54bfbb6b-2731-497f-af2b-878b8addd1fc",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0418),
    lesson: lesson0418,
  },
  {
    id: "430f9718-6530-40c3-beee-3c0037d3490a",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0419),
    lesson: lesson0419,
  },
  {
    id: "765eb79f-cfa5-4e25-840e-daba53078396",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0420),
    lesson: lesson0420,
  },
  {
    id: "1698fcd3-315f-4f86-b4c1-563acddf13f9",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0421),
    lesson: lesson0421,
  },
];

export default lessonLinks;
